import { $api } from '../../global';

export async function getTopUniversities() {
  const { data } = await $api.get('/top-universities');

  return data;
}
